import React, { useState } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../state/stores/user';
import { slide as Menu } from 'react-burger-menu';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Welcome } from '../Welcome';

import styles from './mobileMenu.module.scss';
import './burgerStyles.scss';

export const MobileMenu = ({ menuItems = [], user = {}, logout }) => {
    const [isOpen, setOpen] = useState(false);

    return (
        <>
            <Menu
                isOpen={isOpen}
                onStateChange={state => setOpen(state.isOpen)}
                left
                pageWrapId={'layout'}
            >
                <ul className={styles.mobileNav}>
                    {menuItems.map((link, key) => (
                        <li
                            className={styles.mobileNavItem}
                            key={`mobile-menu--${key}`}
                        >
                            <Link
                                to={link.uri}
                                className={styles.navLink}
                                activeClassName="active"
                                onClick={() => setOpen(false)}
                            >
                                {link.title}
                            </Link>
                        </li>
                    ))}
                </ul>
                <Welcome {...user} logout={logout} mobile={true} />
            </Menu>
        </>
    );
};

MobileMenu.propTypes = {
    user: PropTypes.object,
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            uri: PropTypes.string,
            title: PropTypes.string,
        })
    ).isRequired,
    logout: PropTypes.func.isRequired,
};

export default connect(
    ({ user }) => ({
        user,
    }),
    dispatch => ({
        logout: userActions(dispatch).logout,
    })
)(MobileMenu);
